import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button
} from "@mui/material";

/**
 * Confirmation dialog for archiving one or more vehicles.
 * Renders pluralized copy based on "count" and delegates the actual archive logic to "onSubmit"
 * 
 * @param {Object} props
 * @param {boolean} props.open - Whether the dialog is visible.
 * @param {() => void} props.onClose - Called when the dialog should be closed (cancel, backdrop, etc.).
 * @param {() => void} props.onSubmit - Called when the user confirms the archive action.
 * @param {number} [props.count=0] - Number of vehicles selected for archiving, used for display text.
 */
const BulkArchiveDialog = ({ open, onClose, onSubmit, count = 0 }) => {
  const isPlural = count !== 1;
  const title = isPlural ? `Archive ${count} vehicles` : "Archive vehicle";
  const line  = isPlural
    ? `Are you sure you want to archive these ${count} vehicles?`
    : `Are you sure you want to archive this vehicle?`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers sx={{ pt: 1.5 }}>
        <Typography variant="body2">{line}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="warning" onClick={() => onSubmit()}>
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkArchiveDialog;
